import React from 'react';
import cls from './ChatIndexRoute.module.scss';
const ChatIndexRoute = () => {
  return (
    <div className={cls.Container} data-testid="index-route">
      <h2 className="title-2">Select a chat from the list on the left to start messaging</h2>
    </div>
  );
};

export default ChatIndexRoute;
